__turbopack_context__.v({
  "centerAmounts": "Progress-module__La4f9q__centerAmounts",
  "container": "Progress-module__La4f9q__container",
  "donationContainer": "Progress-module__La4f9q__donationContainer",
  "goalContainer": "Progress-module__La4f9q__goalContainer",
  "label": "Progress-module__La4f9q__label",
  "number": "Progress-module__La4f9q__number",
  "numbersContainer": "Progress-module__La4f9q__numbersContainer",
  "verticalLine": "Progress-module__La4f9q__verticalLine",
});
